export class Parameter {
    constructor(variable, range, required, description) {
        this.variable = variable;
        this.range = range;
        this.required = required;
        this.description = description;
    }
}
//# sourceMappingURL=Parameter.js.map